module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-logo__e5ac4211db00e61b8f19bbf519087a24.png";